import PropTypes from "prop-types";
import React from "react";
import { reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { StringField, DateField, RadioButtons } from "cxa-form-field";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

const required = intl => value =>
  value ? undefined : intl.formatMessage(messages.requiredDescription);
/* Example: may need to add more validators
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength15 = maxLength(15);
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;
const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;
const minValue18 = minValue(18);
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined;
*/
const AddEditDependantForm = ({
  submitting,
  handleSubmit,
  mode,
  submitDependant,
  fields = [],
  cancel,
  intl,
}) => {
  const isAdding = mode == "add";
  const title = isAdding
    ? intl.formatMessage(messages.addDependatTextDescription)
    : intl.formatMessage(messages.editDependantTextDescription);
  const saveButton = isAdding
    ? intl.formatMessage(messages.addTextDescription)
    : intl.formatMessage(messages.saveTextDescription);

  return (
    <form onSubmit={handleSubmit(submitDependant)}>
      <h2>{title}</h2>
      <article className="card">
        <section>
          {fields.map((item, index) => {
            let field;
            const label = {
              label: intl.formatMessage({
                id: item.displayName,
                defaultMessage: item.displayName,
              }),
            };
            if (item.type === "Date") {
              field = (
                <DateField
                  {...label}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                  dateFormat={item.formatter}
                  validate={item.required ? [required(intl)] : null}
                />
              );
            } else if (item.type === "DropDown") {
              field = (
                <RadioButtons
                  {...label}
                  name={item.id}
                  items={item.dropdownValueList.map(item => ({
                    label: intl.formatMessage({
                      id: item.value,
                      defaultMessage: item.value,
                    }),
                    value: item.id,
                  }))}
                  readOnly={item.disabled}
                  required={item.required}
                  validate={item.required ? [required(intl)] : null}
                />
              );

              // field = <SelectField
              //   {...label}
              //   name={ item.id }
              //   items={ item.dropdownValueList.map(item => ({ label: item.value, value: item.id })) }
              //   disabled={ item.disabled }
              //   required={ item.required } />;
            } else if (item.type === "Boolean") {
              field = (
                <RadioButtons
                  {...label}
                  items={[
                    {
                      label: intl.formatMessage({
                        id: "Yes",
                        defaultMessage: "Yes",
                      }),
                      value: "True",
                    },
                    {
                      label: intl.formatMessage({
                        id: "No",
                        defaultMessage: "No",
                      }),
                      value: "False",
                    },
                  ]}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                  validate={item.required ? [required(intl)] : null}
                />
              );
            } else {
              // if (f.type == "String") {
              field = (
                <StringField
                  {...label}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                  validate={item.required ? [required(intl)] : null}
                />
              );
            }
            return <div key={index}>{field}</div>;
          })}
        </section>
      </article>
      <p>
        <Button primary submitting={submitting}>{saveButton}</Button>{" "}
        <Button secondary type="button" onClick={cancel}>
          {intl.formatMessage(messages.cancelTextDescription)}
        </Button>
      </p>
    </form>
  );
};

AddEditDependantForm.propTypes = {
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  mode: PropTypes.string,
  submitDependant: PropTypes.func,
  fields: PropTypes.array,
  cancel: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(
  reduxForm({
    form: "addEditDependant",
    enableReinitialize: true,
  })(AddEditDependantForm)
);



// WEBPACK FOOTER //
// ./components/dependants/AddEditDependantForm.jsx